import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Airports from "../../assets/Data/Airports.json";
import { makeStyles } from "@material-ui/core/styles";
import NumberFormat from "react-number-format";
import "./FormInputs.scss";

export function RadioButton({ ...props }) {
  const [checked, setChecked] = React.useState(false);
  const handleChange = () => {
    setChecked(!checked);
    props.onChange();
  };
  return (
    <label className="RadioContainer">
      <p>{props.label}</p>
      <input
        type="radio"
        checked={checked}
        name={props.name}
        onChange={handleChange}
        value={props.value}
      />
      <span className="RadioCheckmark"></span>
    </label>
  );
}

export function MultilineInput({ ...props }) {
  return (
    <div className="MultilineInputContainer">
      <textarea
        className="MultilineInput"
        type="text"
        id={props.id}
        placeholder="Type..."
        rows="5"
        cols="40"
        value={props.value}
        onChange={props.onChange}
      />
      {props.label ? (
        <label htmlFor={props.name}>{props.label || ""}</label>
      ) : undefined}
    </div>
  );
}

export function DimensionInput({ ...props }) {
  return (
    <div className="DimensionInputContainer">
      <input
        className="DimensionInput"
        type="text"
        key={props.key}
        id={props.id}
        placeholder="Type..."
        value={props.value}
        onChange={props.onChange}
      />
      <label htmlFor={props.id}>{props.label || "Placeholder"}</label>
    </div>
  );
}

export function AddressInput({ ...props }) {
  return (
    <div className="AddressInputContainer" style={props.style}>
      <input
        className="AddressInput"
        type="text"
        id={props.id}
        placeholder="Type..."
        value={props.value}
        onChange={props.onChange}
      />
      <label htmlFor={props.id}>{props.label || ""}</label>
    </div>
  );
}

export function QuotationInput({ className = "QuotationInput", ...props }) {
  /*   console.log(props, 'props from quotation input'); */
  return props.number === true ? (
    <NumberFormat
      disabled={props.disabled}
      onBlur={props.onBlur}
      className={className}
      value={props.value}
      thousandSeparator={true}
      onValueChange={(values) => {
        const { value } = values;
        props.onChange ? props.onChange(value) : console.log();
      }}
    />
  ) : (
    <input
      className={className}
      type='text'
      placeholder={props.placeholder}
      id={props.id}
      value={props.value}
      onChange={props.onChange}
      disabled={props.disabled}
      onBlur={props.onBlur}
    />
  );
}

export function QuotationInputMultiline({ ...props }) {
  return (
    <textarea
      className="QuotationInput"
      type="text"
      rows="3"
      id={props.id}
      value={props.value}
      onChange={props.onChange}
      disabled={props.disabled}
      onBlur={props.onBlur}
    />
  );
}

export function PDFInput({ ...props }) {
  return (
    <div className="PDFInputContainer">
      <input
        className="PDFInput"
        type="text"
        key={props.key}
        id={props.id}
        placeholder={props.placeholder}
        value={props.value}
        onChange={props.onChange}
        style={props.inputStyle}
        disabled={props.disabled}
      />
      <label style={props.labelStyle} htmlFor={props.id}>
        {props.label || "Placeholder"}
      </label>
    </div>
  );
}

const useStyles = makeStyles({
  root: {
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "& .MuiOutlinedInput-input": {
      color: "white",
    },
    "&:hover .MuiOutlinedInput-input": {
      color: "white",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      color: "white",
    },
    "& .MuiInputLabel-outlined": {
      color: "white",
    },
    "&:hover .MuiInputLabel-outlined": {
      color: "white",
    },
    "& .MuiInputLabel-outlined.Mui-focused": {
      color: "white",
    },
    /*   "& .MuiInputBase-input": {
      color: "green",
    }, */
  },
});

export function ComboBox({ ...props }) {
  const classes = useStyles();
  return (
    <Autocomplete
      freeSolo
      value={props.value}
      onChange={(event, value) => props.onChange(event, value)}
      options={Airports.IATA.map(
        (option) => `${option.country} ${option.city} ${option.code}`
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          className={classes.root}
          label={props.label}
          margin="normal"
          variant="outlined"
          InputProps={{ ...params.InputProps }}
        />
      )}
    />
  );
}
